import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import toast from 'react-hot-toast';

const OAuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithGoogle } = useAuth();

  useEffect(() => {
    const handleOAuthCallback = async () => {
      try {

        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');


        if (error) {
          console.error('OAuth Error:', error);
          const errorDescription = urlParams.get('error_description');
          toast.error(`Помилка авторизації: ${error}${errorDescription ? ` - ${errorDescription}` : ''}`);
          navigate('/login');
          return;
        }

        if (!code) {
          console.error('No authorization code received');
          toast.error('Не отримано код авторизації від Google');
          navigate('/login');
          return;
        }


        // Надсилаємо authorization code на backend, який сам обміняє його на токен та user info
        const authResult = await loginWithGoogle({ code });


        if (authResult.success) {
          toast.success('Авторизація успішна!');
          navigate('/');
        } else {
          toast.error(authResult.error || 'Помилка авторизації');
          navigate('/login');
        }

      } catch (error) {
        console.error('OAuth callback error:', error);
        toast.error(`Помилка авторизації: ${error.message}`);
        navigate('/login');
      }
    };

    handleOAuthCallback();
  }, [navigate, loginWithGoogle, location]);

  return (
    <div className="flex h-screen w-screen items-center justify-center">
      <div>
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary-500 mx-auto mb-4"></div>
        <p className="text-center text-gray-600">Завершення авторизації...</p>

        {/* Debug info для розробки */}
        {process.env.NODE_ENV === 'development' && (
          <div className="mt-4 text-xs text-gray-500 text-center max-w-md">
            <p>URL: {window.location.href}</p>
            <p>Search: {window.location.search}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default OAuthCallback;